// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filing-notes-control {
    height: 50px;
    padding-right: 5px;
}

.save-button {
    width: 150px;
    font-weight: 400;
    line-height: 50px;
    font-size: 2rem;
}

.local-form {
    display: flex;
    flex-wrap: wrap;
    padding: 0 40px;
}

.d-col {
    display: flex;
    flex-direction: column;
}

.d-row {
    display: flex;
    flex-direction: row;
}

.note-area {
    width: 100%;
    background-color: rgba(0,0,0,.12);
}

.p-b-10{ padding-bottom: 10px; }

.status-dropdown {
    height: 50px;
    background-color: rgba(0,0,0,.12);
}

.justify-end { justify-content: end; }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/filing-notes/filing-notes.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iCAAiC;AACrC;;AAEA,SAAS,oBAAoB,EAAE;;AAE/B;IACI,YAAY;IACZ,iCAAiC;AACrC;;AAEA,eAAe,oBAAoB,EAAE","sourcesContent":[".filing-notes-control {\n    height: 50px;\n    padding-right: 5px;\n}\n\n.save-button {\n    width: 150px;\n    font-weight: 400;\n    line-height: 50px;\n    font-size: 2rem;\n}\n\n.local-form {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 0 40px;\n}\n\n.d-col {\n    display: flex;\n    flex-direction: column;\n}\n\n.d-row {\n    display: flex;\n    flex-direction: row;\n}\n\n.note-area {\n    width: 100%;\n    background-color: rgba(0,0,0,.12);\n}\n\n.p-b-10{ padding-bottom: 10px; }\n\n.status-dropdown {\n    height: 50px;\n    background-color: rgba(0,0,0,.12);\n}\n\n.justify-end { justify-content: end; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
